import * as runtime from '@/api/runtime'
import {
  BatchReserveCancelListRequest,
  BatchReserveCancelListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchReserveCancelListCondition,
  BatchReserveCancelListConditionFromJSON
} from '@/api/models/batch/BatchReserveCancelListCondition'

/**
 * 帳票作成
 */
export class BatchReserveCancelListApi extends runtime.BaseAPI {
  async return(request: BatchReserveCancelListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/reserve-cancel-list`,
      BatchReserveCancelListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchReserveCancelListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchReserveCancelListConditionFromJSON(jsonValue)
    ).value()
  }
}
